module.exports = __webpack_public_path__ + "static/media/email-open.2fd0e325.jpg";